import { useCurrentCatalogs } from 'hooks';

import CycleCatalog from '../components/CycleCatalog/CycleCatalog';

export const CurrentCycle = () => {
  const { data: currentCatalog, isLoading, isSuccess } = useCurrentCatalogs();

  return (
    <CycleCatalog
      isLoading={isLoading}
      isSuccess={isSuccess}
      catalogs={currentCatalog}
      pageTitle='Ciclo atual'
      description='Compartilhe com seus clientes através da Minha Loja Digital e receba as vendas direto no
        WhatsApp'
    />
  );
};
